// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

/**
 * Schema for decimal day-count fields sent as nullable decimal strings on the
 * wire. Malformed strings fail validation instead of parsing to NaN. Accepts
 * already-parsed numbers so parsed-shape mocks can be re-parsed, mirroring
 * dateTimeSchema.
 */
export const decimalDaysSchema = z
  .union([
    z.number(),
    z.string().transform((days, ctx) => {
      const parsed = parseFloat(days);
      if (!Number.isFinite(parsed)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid decimal days',
        });
        return z.NEVER;
      }

      return parsed;
    }),
  ])
  .nullable();
